import { App } from 'antd';
import { setNotificationApi } from '@/utils/notification/notification';
import { ReactNode } from 'react';

export function NotificationProvider({ children }: { children: ReactNode }) {
  const { notification } = App.useApp();
  setNotificationApi(notification);

  return <>{children}</>;
}
